import { AspNetRole } from '@/models/Enums';

export default class AdminRegistrationRequest {
    email: string;
    role: AspNetRole;
    emailConfirmationUrl: string;

    constructor(
        email: string,
        role: AspNetRole,
        emailConfirmationUrl: string,
    ) {
        this.email = email;
        this.role = role;
        this.emailConfirmationUrl = emailConfirmationUrl;
    }
}